module.exports = __webpack_public_path__ + "static/contraception-5be70fb32a7149eac7af9ea8e1433658.png";